export default {
      id: "flex-alignItems-baseline-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignItems-baseline-usage",
      toString: function () {
        return this.url;
      }
    }